<template>
  <AppLayout>
    <div v-if="isLoading"
      class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style="z-index:1050;background:rgba(255,255,255,0.7);">
      <div class="spinner-border text-primary" role="status" style="width:4rem;height:4rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid mt-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 border-bottom pb-2">
        <div class="d-flex align-items-center gap-3">
          <h4 class="my-0"><strong>{{ check_production_name }}</strong></h4>
          <Link :href="route('check_production.index')" class="btn btn-outline-primary btn-sm">
          <i class="bi bi-list"></i>&nbsp;Powrót do listy
          </Link>
        </div> <!--
                <div class="d-flex align-items-center gap-2">
                    <button v-if="entries.length > 0" @click="wyczysc" class="btn btn-outline-danger btn-sm">
                        <i class="bi bi-trash"></i>&nbsp;Wyczyść tabelę
                    </button>
                </div>-->
      </div>
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-4 mb-3">
        <!--   <div v-if="entries.length == 0">
                    <label for="xlsxFile" class="form-label mb-1 fw-semibold">Wczytaj plik XLSX</label>
                    <input id="xlsxFile" type="file" @change="onFileSelected" accept=".xlsx" class="form-control form-control-sm" style="max-width:400px;" ref="xlsxFileInput">
                </div> -->
        <div v-if="entries.length > 0">
          <button class="btn btn-warning btn-sm" @click="pobierzZeSmart"><i class="bi bi-download"></i>&nbsp;Pobierz ze
            SMART</button>
        </div>
        <div v-if="entries.length > 0" class="position-relative">
          <input type="text" class="form-control form-control-sm pe-5" placeholder="Szukaj..." v-model="searchTermRaw"
            style="min-width:250px;">
          <button class="btn position-absolute end-0 top-0 bottom-0 d-flex align-items-center px-2"
            @click="searchTermRaw = ''" style="border:none;background:transparent;">
            <i class="bi bi-x-lg"></i>
          </button>


        </div>
      </div>

      <div v-if="entries.length > 0" class="production-chart mb-4">
        <div class="production-chart-title">
          Statusy Produkcji
          <span>(Zakończono: {{ completedPercentage }}%)</span>
        </div>

        <apexchart type="bar" height="350" :options="productionChartOptions" :series="productionChartSeries" />
      </div>

      <div v-if="entries.length > 0" class="production-chart mb-4">
        <div class="production-chart-title">
          Zakupowe
          <span>
            (Zrealizowano: {{ zakupoweCompletedPercentage() }}% |
            Ilość: {{ zakupoweQty.toLocaleString('pl-PL') }} szt.)
          </span>
        </div>

        <apexchart type="bar" height="250" :options="zakupoweChartOptions" :series="zakupoweChartSeries" />
      </div>


      <div v-if="entries.length > 0" class="table-responsive">
        <table class="table table-bordered table-hover align-middle">
          <thead>
            <tr>
              <th>#</th>
              <th style="position:sticky;left:0;top:0;background:white;z-index:20;min-width:100px;">Miniatura</th>
              <th @click="sortBy('pozycja')" style="cursor:pointer;min-width:100px;">
                Pozycja
                <i v-if="sortColumn === 'pozycja'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('part_number')" style="cursor:pointer;min-width:150px;">
                Numer części
                <i v-if="sortColumn === 'part_number'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('jednostka')" style="cursor:pointer;">
                J.m.
                <i v-if="sortColumn === 'jednostka'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('qty')" style="cursor:pointer;">
                Ilość
                <i v-if="sortColumn === 'qty'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('description')" style="cursor:pointer;min-width:200px;">
                Opis
                <i v-if="sortColumn === 'description'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('material')" style="cursor:pointer;min-width:150px;">
                Materiał
                <i v-if="sortColumn === 'material'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('bom_structure')" style="cursor:pointer;min-width:150px;">
                BOM Structure
                <i v-if="sortColumn === 'bom_structure'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('masa')" style="cursor:pointer;">
                Masa
                <i v-if="sortColumn === 'masa'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('wer')" style="cursor:pointer;">
                Wersja
                <i v-if="sortColumn === 'wer'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('smart')" style="cursor:pointer;">
                Status ze SMART
                <i v-if="sortColumn === 'smart'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('status')" style="cursor:pointer;">
                Utworzone zapotrzebowanie
                <i v-if="sortColumn === 'status'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th @click="sortBy('required_project_item_id')" style="cursor:pointer;">Nr pozycji zapotrzebowania.</th>
              <th @click="sortBy('inventory_status_id')" style="cursor:pointer;">Status zapotrzebowania</th>



              <th @click="sortBy('barcode')" style="cursor:pointer;">
                BARCODE
                <i v-if="sortColumn === 'barcode'"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th>Ścieżka pliku</th>
              <th>Nazwa pliku</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, index) in sortedEntries" :key="entry.id || index">
              <td>{{ index + 1 }}</td>
              <td style="position:sticky;left:0;background:white;z-index:10;">
                <img v-if="thumbnailUrl(entry)" :src="thumbnailUrl(entry)" alt="miniatura" loading="lazy"
                  style="max-width:80px;max-height:80px;object-fit:contain;cursor:pointer;"
                  @click="openThumbnail(entry)">
              </td>
              <td>{{ entry.pozycja || '' }}</td>
              <td>
                <span v-if="entry.barcode" style="cursor:pointer;text-decoration:underline;"
                  @click="openPdfIfBarcode(entry)">
                  {{ entry.part_number || '' }}
                </span>
                <span v-else>{{ entry.part_number || '' }}</span>
              </td>
              <td>{{ entry.jednostka ?? '' }}</td>
              <td>{{ entry.qty != null ? Number(entry.qty).toFixed(2) : '' }}</td>
              <td>{{ entry.description || '' }}</td>
              <td>
                <center>{{ entry.material || '' }}</center>
              </td>
              <td>
                <center>{{ entry.bom_structure || '' }}</center>
              </td>
              <td>{{ entry.masa ?? '' }}</td>
              <td>
                <center>{{ entry.wer || '' }}</center>
              </td>
              <td>{{ entry.smart || '' }}</td>
              <td>
                <center>{{ entry.status == 1 ? 'TAK' : 'NIE' }}</center>
              </td>
              <td>
                <center>{{ entry.required_project_item_id }}</center>
              </td>
              <td>
                <center>
                  <div class="status-cell">
                    <span v-if="getInventoryStatus(entry.inventory_status_id)?.bg_color" class="status-color" :style="{
                      backgroundColor: getInventoryStatus(entry.inventory_status_id).bg_color
                    }" :title="getInventoryStatus(entry.inventory_status_id).name"></span>

                    <span class="status-text">
                      {{ getInventoryStatus(entry.inventory_status_id)?.name || '' }}
                    </span>
                  </div>
                </center>
              </td>
              <td>
                <center>
                  <img v-if="entry.barcode" :src="route('check_production.barcode', { code: entry.barcode })"
                    alt="Kod kreskowy" style="max-width:180px;height:50px;object-fit:contain;"><br>
                  <h4>{{ entry.barcode || '' }}</h4>
                </center>
              </td>
              <td>{{ entry.sciezka_pliku || '' }}</td>
              <td>{{ entry.nazwa_pliku || '' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-light border mt-4">
        Brak danych. Wybierz plik XLSX, aby rozpocząć import.
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import VueApexCharts from "vue3-apexcharts";
import {
  Link
} from "@inertiajs/vue3";

export default {
  components: {
    AppLayout,
    Link,
    apexchart: VueApexCharts
  },

  props: {
    inventory_statuses: {
      type: Array,
      default: () => []
    },
    prid: {
      type: [String, Number],
      required: true
    },

    check_production_name: {
      type: String,
      default: ''
    },

    archived: {
      type: [Boolean, Number],
      default: false
    },

    check_production_data: {
      type: Array,
      default: () => []
    },

    projects: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      entries: this.check_production_data || [],
      isLoading: false,
      selectedFile: null,
      searchTermRaw: '',
      searchTerm: '',
      debounceTimer: null,
      sortColumn: '',
      sortDirection: 'asc'
    };
  },

  watch: {
    searchTermRaw(newVal) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.searchTerm = newVal;
      }, 200);
    }
  },

  computed: {
    filteredEntries() {
      const term = this.searchTerm?.trim().toLowerCase();

      if (!term) {
        return this.entries;
      }

      const fields = [
        'pozycja',
        'numer_czesci',
        'ilosc_jednostkowa',
        'ilosc',
        'opis',
        'bom_structure',
        'material',
        'masa',
        'wer',
        'smart',
        'barcode',
        'sciezka_pliku',
        'nazwa_pliku'
      ];

      return this.entries.filter(entry => {
        return fields.some(key => {
          const value = entry[key];
          return (
            value !== null &&
            value !== undefined &&
            String(value).toLowerCase().includes(term)
          );
        });
      });
    },

    sortedEntries() {
      const entries = [...this.filteredEntries];
      if (!this.sortColumn) {
        return entries;
      }
      return entries.sort((a, b) => {
        let aVal = a[this.sortColumn];
        let bVal = b[this.sortColumn];
        if (aVal === null || aVal === undefined) {
          aVal = '';
        }
        if (bVal === null || bVal === undefined) {
          bVal = '';
        }
        const aNumber = parseFloat(aVal);
        const bNumber = parseFloat(bVal);

        if (!isNaN(aNumber) && !isNaN(bNumber)) {
          return this.sortDirection === 'asc' ?
            aNumber - bNumber :
            bNumber - aNumber;
        }
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
        if (aVal < bVal) {
          return this.sortDirection === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return this.sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });
    },
    productionStatusData() {
      const statuses = {};

      this.entries.forEach(entry => {
        const status = this.getProductionStatus(entry);
        const qty = parseFloat(entry.qty) || 0;

        statuses[status] = (statuses[status] || 0) + qty;
      });

      return Object.keys(statuses)
        .sort((a, b) => {
          const completed = 'ODBIÓR EL. DO MONTAŻU';

          if (a.toUpperCase() === completed) return -1;
          if (b.toUpperCase() === completed) return 1;

          if (a === 'ZAKUPOWE') return -1;
          if (b === 'ZAKUPOWE') return 1;

          return a.localeCompare(b, 'pl');
        })
        .map(status => ({
          status,
          qty: statuses[status]
        }));
    },

    productionChartSeries() {
      const statuses = {};

      this.entries.forEach(entry => {
        if (this.isPurchased(entry)) return;

        const status = this.getProductionStatus(entry);
        const qty = this.getChartQty(entry);

        statuses[status] = (statuses[status] || 0) + qty;
      });

      const labels = Object.keys(statuses).sort((a, b) => {
        const completed = 'ODBIÓR EL. DO MONTAŻU';

        if (a === completed) return -1;
        if (b === completed) return 1;

        return a.localeCompare(b, 'pl');
      });

      return [{
        name: 'Ilość',
        data: labels.map(label => statuses[label])
      }];
    },

    productionChartOptions() {
      const labels = this.productionChartSeries[0].data.map(
        (_, index) => {
          const statuses = {};

          this.entries.forEach(entry => {
            if (this.isPurchased(entry)) return;

            const status = this.getProductionStatus(entry);
            statuses[status] = true;
          });

          return Object.keys(statuses).sort((a, b) => {
            const completed = 'ODBIÓR EL. DO MONTAŻU';

            if (a === completed) return -1;
            if (b === completed) return 1;

            return a.localeCompare(b, 'pl');
          })[index];
        }
      );

      return this.createChartOptions(labels, 350);
    },

    zakupoweEntries() {
      return this.entries.filter(entry => this.isPurchased(entry));
    },

    zakupoweQty() {
      return this.zakupoweEntries.reduce(
        (sum, entry) => sum + (Number.parseFloat(entry.qty) || 0),
        0
      );
    },


    zakupoweChartSeries() {
      const statuses = {};

      this.zakupoweEntries.forEach(entry => {
        const status = this.getZakupowyStatus(entry);
        const qty = Number.parseFloat(entry.qty) || 0;

        statuses[status] = (statuses[status] || 0) + qty;
      });

      const labels = Object.keys(statuses).sort((a, b) => {
        if (a.toUpperCase() === 'ZREALIZOWANE') return -1;
        if (b.toUpperCase() === 'ZREALIZOWANE') return 1;

        return a.localeCompare(b, 'pl');
      });

      return [{
        name: 'Ilość',
        data: labels.map(label => statuses[label])
      }];
    },

    zakupoweChartOptions() {
      const labels = [...new Set(
        this.zakupoweEntries.map(entry => this.getZakupowyStatus(entry))
      )].sort((a, b) => {
        if (a.toUpperCase() === 'ZREALIZOWANE') return -1;
        if (b.toUpperCase() === 'ZREALIZOWANE') return 1;

        return a.localeCompare(b, 'pl');
      });

      const options = this.createChartOptions(labels, 250, true);

      return {
        ...options,
        colors: labels.map(status => this.getZakupowyStatusColor(status))
      };
    },



    completedPercentage() {
      const completedStatus = 'ODBIÓR EL. DO MONTAŻU';
      let totalQty = 0;
      let completedQty = 0;
      this.entries.forEach(entry => {
        if (this.isPurchased(entry)) {
          return;
        }
        const qty = this.getChartQty(entry);
        const status = this.getProductionStatus(entry);
        totalQty += qty;
        if (status === completedStatus) {
          completedQty += qty;
        }
      });

      if (totalQty === 0) {
        return '0,00';
      }

      return ((completedQty / totalQty) * 100)
        .toFixed(2)
        .replace('.', ',');
    },

  },

  mounted() {
    this.loadData();
  },

  methods: {
    getZakupowyStatusColor(statusName) {
      const entry = this.zakupoweEntries.find(entry =>
        this.getZakupowyStatus(entry) === statusName
      );

      if (!entry) {
        return '#dc3545';
      }
      const inventoryStatus = this.getInventoryStatus(
        entry.inventory_status_id
      );
      if (inventoryStatus?.bg_color) {
        return inventoryStatus.bg_color;
      }

      if (statusName.toUpperCase() === 'ZREALIZOWANE') {
        return '#198754';
      }

      return '#dc3545';
    },
    isPurchased(entry) {
      const bom = String(entry.bom_structure ?? '')
        .trim()
        .toLowerCase();

      return ['purchased', 'kupiony'].includes(bom);
    },
    getChartQty(entry) {
      if (!this.isPurchased(entry)) {
        const unit = String(entry.jednostka ?? '')
          .trim()
          .toLowerCase();

        if (unit !== 'szt') {
          return 1;
        }
      }

      return Number.parseFloat(entry.qty) || 0;
    },
    createChartOptions(labels, height = 350, isZakupowe = false) {
      return {
        chart: {
          type: 'bar',
          height: height,
          toolbar: {
            show: false
          }
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: isZakupowe ? '30%' : '55%',
            borderRadius: 4,
            distributed: true
          }
        },

        colors: labels.map(label => {
          if (label === 'ODBIÓR EL. DO MONTAŻU') {
            return '#198754';
          }

          return '#dc3545';
        }),

        xaxis: {
          categories: labels
        },

        yaxis: {
          min: 0,
          title: {
            text: 'Ilość szt.'
          }
        },

        dataLabels: {
          enabled: true,
          formatter: value => `${value} szt.`
        },

        tooltip: {
          y: {
            formatter: value => `${value} szt.`
          }
        },

        legend: {
          show: false
        },

        noData: {
          text: 'Brak danych do wyświetlenia'
        }
      };
    },


    getProductionStatus(entry) {
      if (this.isPurchased(entry)) {
        return this.getZakupowyStatus(entry);
      }

      const productionStatus = Number(entry.status);
      const inventoryStatusId = Number(entry.inventory_status_id);

      if (
        productionStatus === 1 &&
        inventoryStatusId === 4
      ) {
        return 'ODBIÓR EL. DO MONTAŻU';
      }

      const smart = String(entry.smart ?? '').trim();

      if (smart !== '') {
        return smart;
      }

      return 'BRAK RYSUNKU';
    },

    getZakupowyStatus(entry) {
      const inventoryStatus = this.getInventoryStatus(
        entry.inventory_status_id
      );

      const statusName = String(
        inventoryStatus?.name ?? ''
      ).trim();

      if (statusName.toLowerCase() === 'zrealizowane') {
        return 'ZREALIZOWANE';
      }

      const smart = String(entry.smart ?? '').trim();

      if (smart.toLowerCase() === 'zrealizowane') {
        return 'ZREALIZOWANE';
      }

      return statusName || smart || 'OCZEKUJE';
    },


    zakupoweCompletedPercentage() {
      const completedStatus = 'ZREALIZOWANE';

      let totalQty = 0;
      let completedQty = 0;

      this.zakupoweEntries.forEach(entry => {
        const qty = Number.parseFloat(entry.qty) || 0;

        totalQty += qty;

        if (this.getZakupowyStatus(entry) === completedStatus) {
          completedQty += qty;
        }
      });

      if (totalQty === 0) {
        return '0,00';
      }

      return ((completedQty / totalQty) * 100)
        .toFixed(2)
        .replace('.', ',');
    },

    getInventoryStatus(statusId) {
      return this.inventory_statuses?.find(
        status => Number(status.id) === Number(statusId)
      ) || null;
    },
    async loadData() {
      this.isLoading = true;

      try {
        const response = await fetch(
          route('check_production.data', {
            prid: this.prid
          }), {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          },
          credentials: 'same-origin',
          cache: 'no-store'
        }
        );

        if (!response.ok) {
          const text = await response.text();

          console.error(
            'Błąd pobierania danych:',
            response.status,
            text
          );

          throw new Error(
            `Błąd pobierania danych (${response.status})`
          );
        }

        const data = await response.json();

        let rows = [];

        if (Array.isArray(data)) {
          rows = data;
        } else if (Array.isArray(data.data)) {
          rows = data.data;
        }

        const normalizedRows = rows.map(entry => {
          const status = Number(entry.status);

          let inventoryStatusId = null;

          if (
            entry.inventory_status_id !== null &&
            entry.inventory_status_id !== undefined &&
            entry.inventory_status_id !== ''
          ) {
            const parsed = Number(entry.inventory_status_id);

            if (Number.isFinite(parsed)) {
              inventoryStatusId = parsed;
            }
          }

          return {
            ...entry,

            status: Number.isFinite(status)
              ? status
              : 0,

            inventory_status_id: inventoryStatusId,

            qty: Number.parseFloat(entry.qty) || 0
          };
        });

        this.entries = normalizedRows;

      } catch (error) {
        console.error('loadData error:', error);

        this.entries = [];

        this.showToast(
          'error',
          'Błąd',
          'Nie udało się pobrać danych.'
        );

      } finally {
        this.isLoading = false;
      }
    },

    thumbnailUrl(entry) {
      if (!entry) {
        return '';
      }
      if (
        entry.miniatura &&
        (
          entry.miniatura.startsWith('http://') ||
          entry.miniatura.startsWith('https://') ||
          entry.miniatura.startsWith('/')
        )
      ) {
        return entry.miniatura;
      }

      const filename =
        entry.miniatura ||
        entry.nazwa_pliku;

      if (!filename) {
        return '';
      }

      return route('check_production.thumbnail', {
        prid: this.prid,
        filename: filename
      });
    },

    openThumbnail(entry) {
      const url = this.thumbnailUrl(entry);
      if (!url) {
        this.showToast(
          'warning',
          'Brak miniatury',
          'Dla tego elementu nie znaleziono miniatury.'
        );
        return;
      }
      window.open(url, '_blank');
    },

    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      if (!file.name.toLowerCase().endsWith('.xlsx')) {
        this.showToast('error', 'Błąd', 'Wybierz plik XLSX.');
        event.target.value = null;
        return;
      }
      this.selectedFile = file;
      this.uploadFile();
    },

    async uploadFile() {
      if (!this.selectedFile) {
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();

        formData.append('file', this.selectedFile);
        formData.append('prid', this.prid);

        const response = await fetch(
          route('check_production.upload'), {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute('content'),

            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: formData
        }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.error ||
            data.message ||
            'Błąd podczas przesyłania pliku.'
          );
        }

        await this.loadData();

        this.showToast(
          'success',
          'Import zakończony',
          `Wczytano ${this.entries.length} rekordów.`
        );

      } catch (error) {
        console.error('Błąd uploadu:', error);

        this.showToast(
          'error',
          'Błąd',
          error.message || 'Nie udało się przetworzyć pliku.'
        );

      } finally {
        this.isLoading = false;
        this.selectedFile = null;

        if (this.$refs.xlsxFileInput) {
          this.$refs.xlsxFileInput.value = null;
        }
      }
    },

    async wyczysc() {
      if (
        !confirm(
          'Na pewno wyczyścić tabelę i usunąć wpisy z bazy?'
        )
      ) {
        return;
      }
      this.isLoading = true;
      try {
        const csrfToken =
          document
            .querySelector('meta[name="csrf-token"]')
            ?.getAttribute('content');

        const response = await fetch(
          route('check_production.data.delete', {
            prid: this.prid
          }), {
          method: 'DELETE',
          headers: {
            'X-CSRF-TOKEN': csrfToken,
            'Accept': 'application/json'
          },
          credentials: 'same-origin'
        }
        );
        /*
                if (!response.ok) {
                  const text = await response.text();
                  console.error(
                    'Błąd czyszczenia:',
                    response.status,
                    text
                  );
                  throw new Error(
                    'Błąd usuwania danych'
                  );
                }*/
        this.entries = [];
        this.showToast(
          'success',
          'Gotowe',
          'Tabela została wyczyszczona.'
        );

      } catch (error) {
        console.error(error);
        this.showToast(
          'error',
          'Błąd',
          'Nie udało się usunąć danych.'
        );

      } finally {
        this.isLoading = false;
      }
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection =
          this.sortDirection === 'asc' ?
            'desc' :
            'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },

    async openPdfIfBarcode(entry) {
      if (!entry.barcode) {
        this.showToast(
          'warning',
          'Brak danych',
          'Brak kodu kreskowego.'
        );

        return;
      }

      const fileName =
        entry.barcode + '.pdf';
      const downloadUrl =
        route(
          'check_production.files.download', {
          file: fileName
        }
        );

      try {
        const response = await fetch(
          downloadUrl, {
          method: 'HEAD',
          credentials: 'same-origin'
        }
        );

        if (response.ok) {
          window.open(
            downloadUrl,
            '_blank'
          );
        } else {
          this.showToast(
            'warning',
            'Brak pliku',
            'Plik PDF nie istnieje.'
          );
        }

      } catch (error) {
        console.error(error);

        this.showToast(
          'error',
          'Błąd',
          'Nie udało się sprawdzić pliku PDF.'
        );
      }
    },

    async pobierzZeSmart() {
      const expr1 = this.check_production_name?.split('-')?.[0]?.trim();
      if (!expr1 || !this.prid) {
        this.showToast("error", "Błąd", "Brakuje danych do pobrania ze SMART");
        return;
      }
      this.isLoading = true;
      try {
        await axios.get(
          `/check_production/smart-list/${expr1}/${this.prid}`
        );
        this.showToast(
          'success',
          'Zapisano',
          'Dane ze SMART zostały zaktualizowane.'
        );

      } catch (error) {
        console.error(error);

        this.showToast(
          'error',
          'Błąd',
          'Nie udało się pobrać danych ze SMART.'
        );

      } finally {
        this.isLoading = false;

        await this.loadData();
      }
    },

    showToast(icon, title, message) {
      if (typeof Toast === 'undefined') {
        alert(`${title}: ${message}`);
        return;
      }

      Toast.fire({
        position: 'top-end',
        toast: true,
        icon,
        title,
        html: message,

        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },

        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },

        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>

<style scoped>
.table-responsive {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.table thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.table thead th:nth-child(2) {
  left: 0;
  z-index: 20;
}

.production-chart-title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 10px;
}

.production-chart-title span {
  color: #198754;
}

.status-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  width: 100%;
}

.status-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
}

.status-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
</style>